module.exports = __webpack_public_path__ + "img/user-outline.18dfe14a.svg";